import type { InputFrame } from '../core/types';

export interface RogfusDebug { player: { x: number; y: number; hp: number } | null; monsters: number; input: InputFrame | null; touch: boolean; time: number; camera?: { x: number; y: number; following: boolean }; room?: { id: string; map: boolean }; run?: { phase: string; roomIndex: number; boss: string | null; doors: { reward: string; x: number; y: number }[]; monsterPos: { x: number; y: number }[]; pets: number }; }
declare global { interface Window { __rogfusDebug?: RogfusDebug; } }

/** Actif uniquement avec ?debug=1 dans l'URL : expose l'état du jeu aux tests de bout en bout. */
export function debugEnabled(): boolean {
  try { return new URLSearchParams(window.location.search).get('debug') === '1'; } catch { return false; }
}

/** Évalué une seule fois au chargement : en production, aucune allocation par image côté appelant (`if (DEBUG)`). */
export const DEBUG = debugEnabled();

export function publishDebug(d: RogfusDebug): void {
  window.__rogfusDebug = d;
}
